import React from 'react';
import { ColumnDefinition, CoreRouterLink } from '@amzn/dots-core-ui';
import { Project } from '$/api';
import { ProjectDetailUri } from '$/features/routes';

export const ProjectColumnDefinitions: ColumnDefinition<Project>[] = [
  {
    id: 'name',
    header: 'Name',
    item: ({ id, name }): JSX.Element => (
      <CoreRouterLink href={ProjectDetailUri(id)}>{name}</CoreRouterLink>
    ),
  },
  {
    id: 'product',
    header: 'Product',
    item: ({ product }): string => product || '-',
  },
  {
    id: 'product_family',
    header: 'Product Family',
    item: ({ product_family }): string => product_family || '-',
  },
  {
    id: 'created',
    header: 'Created',
    item: ({ created }): string =>
      created instanceof Date
        ? created.toLocaleDateString()
        : new Date(created).toLocaleDateString(),
  },
  {
    id: 'active',
    header: 'Status',
    item: ({ active }): string => (active ? 'Active' : 'Inactive'),
  },
];
